import { Theme } from 'config/theme/types';
import { zdfColorsDark } from './zdf-color-dark';
import { zdfColorsLight } from './zdf-color-light';
import { zdfFontFamilies } from './zdf-font-families';

export const zdfThemeNames = ['zdf', 'zdfHeuteDark', 'zdfHeuteLight'] as const;
export type ZdfThemeName = typeof zdfThemeNames[number];

const loadZdfFonts = async () => {
    try {
        const fontModule = await import('./zdf-font.ts')
        await fontModule.getZdfFonts(); 
    } catch {
        console.error("Loading custom fonts failed")
    } 
}

export const zdfThemes: Record<ZdfThemeName, Theme> = {
    zdf: {
        colors: zdfColorsDark,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts
    },
    zdfHeuteDark: {
        colors: zdfColorsDark,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts
    },
    zdfHeuteLight: {
        colors: zdfColorsLight,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts
    }
}